import { render, staticRenderFns } from "./invest_bank.vue?vue&type=template&id=b7ab6e0e&scoped=true"
import script from "./invest_bank.vue?vue&type=script&lang=js"
export * from "./invest_bank.vue?vue&type=script&lang=js"
import style0 from "./invest_bank.vue?vue&type=style&index=0&id=b7ab6e0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ab6e0e",
  null
  
)

export default component.exports